import { useEffect } from 'preact/hooks'
import type { RefObject } from 'preact'

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  onClose: () => void,
  isOpen: boolean,
) {
  useEffect(() => {
    if (!isOpen) return

    function handler(e: MouseEvent) {
      // e.composedPath() is required for Shadow DOM — e.target is retargeted
      // to the shadow host and would incorrectly match on internal clicks.
      const path = e.composedPath()
      if (ref.current && !path.includes(ref.current)) {
        onClose()
      }
    }

    window.addEventListener('mousedown', handler)
    return () => window.removeEventListener('mousedown', handler)
  }, [isOpen, ref, onClose])
}
